module.exports = __webpack_public_path__ + "static/media/chloe-nomade-big.7e8b6281.png";